import fsmToggleMenu from './fsm/toggle_menu';

const toggleMenu = function($container, $trigger) {
  const container = $container || $('body');
  const $toggleMenu = container.find($trigger);
  const $nav = container.find($('@nav'));
  const $toggleClass = 'toggle_menu-open';
  const $toolbar = container.find('@toolbar');
  const $main = container.find($('@main'));

  $toggleMenu.on('click', (e) => {
    e.preventDefault();
    fsmToggleMenu.toggle();
  });

  const closeHandler = () => {
    if ($(window).width() <= 768) {
      $toolbar.show();
    }

    $toggleMenu.removeClass($toggleClass);
    $nav.stop().fadeOut();
    $main.stop().fadeIn();
    container.off();
  };

  const openHandler = () => {
    $toolbar.hide();
    $nav.stop().fadeIn();
    $main.stop().fadeOut();
    $toggleMenu.addClass($toggleClass);
    closeControllsInit();
  };

  const fsmTrigger = () => {
    switch (fsmToggleMenu.state) {
      case 'closed':
        closeHandler();
        break;
      case 'opened':
        openHandler();
        break;
      default:
        break;
    }
  };

  fsmToggleMenu.observe({
    onEnterState() {
      fsmTrigger();
    },
  });

  function closeControllsInit() {
    container.on('keydown', (e) => {
      if (e.keyCode === 27) {
        fsmToggleMenu.toggle();
      }
    });

    container.on('click', (e) => {
      if (!$(e.target).closest($('.nav')).length && !$(e.target).closest($('.header__right')).length) {
        fsmToggleMenu.toggle();
      }
    });
  }
};


export default toggleMenu;
